
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterFilter1Off as ObiConverterFilter1OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-filter-1-off.js';
 
 
 

 
 export const ObiConverterFilter1Off = createComponent({
   react: React,
   tagName: 'obi-converter-filter-1-off',
   elementClass: ObiConverterFilter1OffElement,
   events: {
     
   }
  });
 
 